import React from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  CardActions,
} from "@mui/material";

const CreationCard = ({ data, onClick }) => {
  const { image_url, user_name } = data;

  return (
    <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <CardMedia
        component='img'
        height='100%'
        image={image_url}
        alt='Creación'
        onClick={onClick}
        sx={{ cursor: "pointer" }}
      />
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography gutterBottom variant='h6'>
          Creación de {user_name}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size='small' onClick={onClick}>
          Ver detalles
        </Button>
        <Button size='small' variant='contained' color='secondary'>
          Agregar productos
        </Button>
      </CardActions>
    </Card>
  );
};

export default CreationCard;
